import { routes as auth } from '../modules/auth'
import { routes as confirmation } from '../modules/confirmation'
import { routes as home } from '../pages/home'
import { routes as settings } from '../pages/settings'
import { routes as settingsEvent } from '../pages/settings/event'
import { routes as settingsRSVP } from '../pages/settings/rsvp'
import { routes as financialControl } from '../pages/settings/financial-control'
import { routes as reports } from '../pages/settings/reports'
import { routes as filters } from '../pages/settings/filters'
import { routes as users } from '../pages/admin/users'
import { routes as schedules } from '../pages/settings/schedules'
import { routes as speakers } from '../pages/settings/speakers'
import { routes as sponsors } from '../pages/settings/sponsors'
import { routes as faqs } from '../pages/settings/faqs'
import { routes as emailSuppressions } from '../pages/settings/email-suppressions'
import { routes as testimonials } from '../pages/settings/testimonials'
import { routes as photos } from '../pages/settings/photos'
import { routes as videos } from '../pages/settings/videos'
import { routes as customization } from '../pages/settings/customization'
import { routes as groups } from '../pages/groups'
import { routes as forms } from '../pages/forms'
import { routes as formBuilder } from '../pages/form-builder'
import { routes as participantCardBuilder } from '../pages/participant-card-builder'
import { routes as emailTemplate } from '../pages/settings/Email'
import { routes as participant } from '../pages/participants'
import { routes as campaign } from '../pages/wa/campaign'
import { routes as messenger } from '../pages/wa/messenger'
import { routes as ecampaign } from '../pages/email/campaign'
import { routes as template } from '../pages/wa/templates'
import { routes as wa } from '../pages/settings/wa'
import { routes as inep } from '../pages/ineps'
import { routes as registrationControl } from '../pages/registration-controls'
import { routes as guest } from '../pages/guests'
import { routes as tag } from '../pages/tags'
import { routes as seating } from '../pages/seating'
import { routes as cupon } from '../pages/cupons'
import { routes as checkIn } from '@/modules/check-in'
import { routes as report } from '../pages/reports'
import { routes as tasks } from '../pages/settings/tasks'
import { routes as flightBlocks } from '../pages/settings/flight-blocks'
import { routes as settingcheck } from '../pages/settingscheckin'
import { routes as checkinDashboard } from '../pages/checkin-dashboard'
import { routes as roomlist } from '../pages/roomlist'
import { routes as payments } from '../pages/payments'
import { routes as badgeBuilder } from '../pages/badge-builder'
import { routes as storage } from '@/modules/storage'
import { routes as storageAdmin } from '../pages/storage-admin'
import { routes as followUpRules } from '../pages/settings/follow-up-rules'
import { routes as journeyBuilder } from '../pages/journey-builder'
import { routes as cartaPax } from '../pages/carta-pax'
import { routes as analytics } from '../pages/analytics'
import { routes as eventDashboard } from '../pages/event-dashboard'
import { routes as dataIntegrations } from '../pages/settings/data-integrations'
import { routes as trilhaPresencial } from '../pages/settings/trilha-presencial'
import { routes as app } from '../pages/app'

export default [
  ...eventDashboard,
  ...auth,
  ...confirmation,
  ...home,
  ...settings,
  ...settingsEvent,
  ...settingsRSVP,
  ...financialControl,
  ...reports,
  ...filters,
  ...users,
  ...schedules,
  ...speakers,
  ...sponsors,
  ...faqs,
  ...emailSuppressions,
  ...testimonials,
  ...photos,
  ...videos,
  ...customization,
  ...emailTemplate,
  ...groups,
  ...forms,
  ...formBuilder,
  ...participantCardBuilder,
  ...participant,
  ...ecampaign,
  ...campaign,
  ...messenger,
  ...template,
  ...wa,
  ...guest,
  ...inep,
  ...registrationControl,
  ...checkIn,
  ...seating,
  ...tag,
  ...cupon,
  ...tasks,
  ...flightBlocks,
  ...report,
  ...settingcheck,
  ...checkinDashboard,
  ...roomlist,
  ...payments,
  ...badgeBuilder,
  ...storage,
  ...storageAdmin,
  ...followUpRules,
  ...journeyBuilder,
  ...cartaPax,
  ...analytics,
  ...dataIntegrations,
  ...trilhaPresencial,
  ...app
]
